import { ApiBase } from './api-base';

/**
 * @template R
 * @typedef {import('axios').AxiosResponse<R>} AxiosResponse<R>
 */

/**
 * @typedef {import('../types/additional-request-options.interface').AdditionalRequestOptions} AdditionalRequestOptions
 */
export class PermissionsApi extends ApiBase {
  /**
   * In-memory cache of the (parameterless, session-scoped) absence-calc
   * permission check — the answer is identical regardless of which
   * component asks, so it's memoized here once instead of being re-fetched
   * by every caller (Timesheet, Matrix Report, Reports) on every mount.
   * Cleared on logout.
   * @type {Promise<AxiosResponse<{ allowed: boolean }>> | null}
   */
  absenceCalcPermission = null;

  /**
   * @param {string} action
   * @param {string} resource
   * @param {string} [projectId]
   * @param {string} [status]
   * @param {AdditionalRequestOptions} [options]
   * @returns {Promise<AxiosResponse<{ allowed: boolean }>>}
   */
  allowedTo = (
    action,
    resource,
    projectId,
    status,
    options,
  ) => this.apiClient.sendRequest({
    method: 'GET',
    url: `permissions/to/${action}/${resource}`,
    params: {
      project_id: projectId,
      status,
    },
  }, options);

  getAbsenceCalc = () => {
    if (!this.absenceCalcPermission) {
      this.absenceCalcPermission = this.apiClient.sendRequest({
        method: 'GET',
        url: 'permissions/to/read/absence-calc',
      }).catch((error) => {
        this.absenceCalcPermission = null;

        throw error;
      });
    }

    return this.absenceCalcPermission;
  };
}
